module.exports = __webpack_public_path__ + "static/img/message-alert-character2.13d5887.png";